module.exports = __webpack_public_path__ + "static/media/logo.d1a1fa7a.svg";